import React, { useRef, useState } from "react";
import { uploadChunked } from "../lib/upload";
import { authStore } from "../lib/api";
import { toast } from "./ui/sonner";
import { Loader2, Upload, FileCheck2 } from "lucide-react";

export const w9FileUrl = (api, fid) => `${api.defaults.baseURL}/files/${fid}/download?auth=${encodeURIComponent(authStore.get("ali_token") || "")}`;

export const W9Upload = ({ api, zh, value, onChange, idBase = "w9", fileIdKey = "w9FileId", filenameKey = "w9Filename", label }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = (e.target.files || [])[0]; if (!f) return;
    setBusy(true);
    try {
      const fin = await uploadChunked(api, f);
      onChange({ [fileIdKey]: fin.fileId, [filenameKey]: f.name });
      toast.success(zh ? "扫描件已上传" : "Uploaded");
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "上传失败" : "Upload failed")); }
    setBusy(false); if (ref.current) ref.current.value = "";
  };
  const fid = value?.[fileIdKey];
  const fname = value?.[filenameKey];
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      <input ref={ref} type="file" accept="image/*,application/pdf" className="hidden" data-testid={`${idBase}-file-input`} onChange={pick} />
      <button type="button" data-testid={`${idBase}-upload-btn`} disabled={busy} onClick={() => ref.current?.click()}
        className="inline-flex items-center gap-1 text-[11px] text-indigo-600 border border-indigo-200 hover:bg-indigo-50 rounded px-2 py-1 disabled:opacity-50">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Upload className="h-3 w-3" />}
        {fid ? (zh ? "重新上传" : "Replace") : (label || (zh ? "上传 W-9 扫描件" : "Upload W-9"))}
      </button>
      {fid && (
        <a data-testid={`${idBase}-view-link`} href={w9FileUrl(api, fid)} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1 text-[11px] text-emerald-700 hover:underline">
          <FileCheck2 className="h-3 w-3" /><span className="max-w-[120px] truncate">{fname || "file"}</span>
        </a>
      )}
    </span>
  );
};
